export default "__VITE_ASSET__Fq_PY690__"